import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image as Image$1, Text, TouchableOpacity, StyleSheet, ScrollView, Platform } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppDot } from './index-0ee62650.esm.js';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { Popable } from 'react-native-popable';
import MarkdownIt from 'markdown-it';
import mermaid from 'mermaid';
import { A as AppAssets } from './index-3256db5b.esm.js';
import * as URL from 'url';
import hljs from 'highlight.js';
import zenuml from '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import { debounce } from 'lodash-es';
import Markdown from 'react-native-markdown-display';

var _window;
const isElectron = !!((_window = window) !== null && _window !== void 0 && _window.electronAPI);

const AppIcon = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
  let {
    activeColor,
    color,
    size = 18,
    height = size,
    width = size,
    icon,
    label,
    style,
    labelStyle,
    onPress,
    imageSource,
    isActive,
    isClickable,
    isHoverable,
    imageBorderRadius,
    onLayout,
    justifyHorizontally,
    emoji,
    emojiStyle,
    wrapperStyle,
    accessibilityLabel,
    tooltip,
    popableViewStyle,
    showToRight = true,
    showToLeft = false
  } = _ref;
  const isEmoji = emoji != null;
  const {
    currentTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isMouseHover, setIsMouseHover] = React__default.useState(false);
  const _style = styleGenerator({
    currentTheme,
    borderRadius: size,
    justifyHorizontally,
    height,
    width
  });
  color = color ? color : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary;
  activeColor = activeColor ? activeColor : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary;
  const coreImage = /*#__PURE__*/React__default.createElement(View, {
    ref: ref,
    onLayout: onLayout,
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    style: [_style.iconImage, style]
  }, label && showToLeft && /*#__PURE__*/React__default.createElement(AppText, {
    style: labelStyle
  }, label), icon && !isEmoji && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    color: isActive || isHoverable && isMouseHover ? activeColor : color,
    size: size,
    icon: icon,
    accessibilityLabel: accessibilityLabel
  }), imageSource && !isEmoji && (isElectron ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      borderRadius: imageBorderRadius,
      width,
      height,
      objectFit: "contain" // Standard web equivalent of resizeMode
    },

    src: imageSource,
    alt: "" // Add meaningful alt text if possible
  }) : /*#__PURE__*/React__default.createElement(Image$1, {
    style: {
      borderRadius: imageBorderRadius,
      width,
      height,
      resizeMode: "contain"
    },
    source: imageSource
  })), emoji && /*#__PURE__*/React__default.createElement(Text, {
    style: [_style.emoji, emojiStyle]
  }, emoji), label && showToRight && /*#__PURE__*/React__default.createElement(AppText, {
    style: labelStyle
  }, label));
  const poppableImage = tooltip ? /*#__PURE__*/React__default.createElement(Popable, {
    numberOfLines: 2,
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.tooltipBackgroundColor,
    style: [{
      top: 40,
      zIndex: 20,
      maxWidth: 300
    }, popableViewStyle],
    content: t(tooltip),
    action: "hover",
    position: "bottom"
  }, coreImage) : coreImage;
  return /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    style: wrapperStyle,
    disabled: !isClickable,
    onPress: onPress
  }, poppableImage);
});
const styleGenerator = _ref2 => {
  var _currentTheme$theme4;
  let {
    currentTheme,
    size,
    justifyHorizontally,
    height,
    width
  } = _ref2;
  return StyleSheet.create({
    iconImage: {
      width,
      height,
      borderRadius: size,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: justifyHorizontally ? "row" : "column",
      flex: 1
    },
    emoji: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.primary,
      fontSize: size
    }
  });
};
AppIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppIcon",
  "props": {
    "size": {
      "defaultValue": {
        "value": "18",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "size",
        "computed": true
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "size",
        "computed": true
      },
      "required": false
    },
    "showToRight": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "showToLeft": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

function LinkPreview(_ref) {
  var _currentTheme$theme;
  let {
    url
  } = _ref;
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const {
    currentTheme,
    mode
  } = useTheme();
  // create a function to extract the domain from the url including http or https
  function extractDomain(urlString) {
    if (!urlString) {
      return "";
    }
    const urlObj = URL.parse(urlString);
    return urlObj.protocol + "//" + urlObj.host;
  }

  // create a function that checks if previewData.image starts with a slash, append the domain to it
  const appendDomain = (url, image) => {
    if (image !== null && image !== void 0 && image.startsWith("/")) {
      const domain = extractDomain(url);
      return "".concat(domain).concat(image);
    }
    return image;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const data = await response.text();
        const isYouTubeVideo = isYouTubeURL(url);
        if (isYouTubeVideo) {
          const videoId = extractYouTubeVideoId(url);
          const videoThumbnail = "https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg");
          setPreviewData({
            videoId,
            videoThumbnail
          });
          setLoading(false);
        } else {
          var _doc$querySelector, _doc$querySelector2, _doc$querySelector3;
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const title = ((_doc$querySelector = doc.querySelector("title")) === null || _doc$querySelector === void 0 ? void 0 : _doc$querySelector.textContent) || "";
          const description = ((_doc$querySelector2 = doc.querySelector('meta[name="description"]')) === null || _doc$querySelector2 === void 0 ? void 0 : _doc$querySelector2.getAttribute("content")) || "";
          const image = ((_doc$querySelector3 = doc.querySelector('meta[property="og:image"]')) === null || _doc$querySelector3 === void 0 ? void 0 : _doc$querySelector3.getAttribute("content")) || "";
          setPreviewData({
            title,
            description,
            image
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    // ensure url does not have toothfairyai.com or toothfairylab.link in it
    if (!(url !== null && url !== void 0 && url.includes("toothfairyai.com")) && !(url !== null && url !== void 0 && url.includes("toothfairylab.link")) && !(url !== null && url !== void 0 && url.includes("files-to-import-aus"))) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [url]);
  const isYouTubeURL = url => {
    return url.includes("youtube.com") || url.includes("youtu.be");
  };
  const extractYouTubeVideoId = url => {
    const videoIdRegex = /(?:\/embed\/|\/watch\?v=|\/(?:embed\/|v\/|watch\?.*v=|youtu\.be\/|embed\/|v=))([^&?#]+)/;
    const match = url.match(videoIdRegex);
    return match ? match[1] : "";
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontSize: 12
      }
    }, "Loading...");
  }
  if (!previewData) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
    // <AppText
    //   style={{
    //     fontSize: 12,
    //   }}
    // >
    //   Failed to fetch link preview
    // </AppText>
    ;
  }

  const handleClick = () => {
    window.open(url, "_blank");
  };
  if (previewData.videoId) {
    return /*#__PURE__*/React__default.createElement("div", {
      onClick: handleClick,
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: previewData.videoThumbnail,
      alt: "Video Thumbnail"
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    style: {
      cursor: "pointer",
      width: 300,
      margin: 5,
      border: "1px solid ".concat(currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.border_color),
      padding: 5,
      borderRadius: 5
    }
  }, /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      fontSize: 12
    },
    fontWeight: "bold"
  }, previewData.title), /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      fontSize: 12
    }
  }, previewData.description), previewData.image && /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: 300
    },
    src: appendDomain(url, previewData === null || previewData === void 0 ? void 0 : previewData.image),
    alt: "Link Preview"
  }));
}
LinkPreview.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkPreview"
};

const markdownItKatex = require("markdown-it-katex");
var mila = require("markdown-it-link-attributes");
window.viewHTML = function (id) {
  const content = document.getElementById(id + "_code").textContent;
  const newTab = window.open();
  newTab.document.write(content);
  newTab.document.close();
};
const MarkdownRenderer = _ref => {
  var _currentTheme$theme38, _currentTheme$theme39, _currentTheme$theme40, _currentTheme$theme41, _AppAssets$icons, _AppAssets$icons2, _AppAssets$icons3, _AppAssets$icons4, _currentTheme$theme42, _currentTheme$theme43, _currentTheme$theme44, _currentTheme$theme45;
  let {
    markdownText,
    style,
    showCopyButton,
    S3downloadUrlRequest,
    workspaceid,
    onCopy = () => {},
    copyIconColor,
    renderHTMLinMarkdown = true,
    coder = false,
    customChartingConfig,
    showFeedbackButtons,
    onPositiveFeedbackPress = () => {},
    onNegativeFeedbackPress = () => {},
    isSpeechGettingProcessed = false,
    updateTextForSpeech = () => {},
    showTextToSpeech = false,
    showCodeInExecution = true,
    renderDynamicHTML = true,
    renderHTMLLinkPreview = true,
    hideReasoning = false
  } = _ref;
  // check if markdown text last characters are a message streaming symbol (e.g., \u26AB or \u26AA) and adjust accordingly.
  const [isMessageStreaming, setIsMessageStreaming] = useState(markdownText.endsWith("\u26AB") || markdownText.endsWith("\u26AA"));
  const [finalAnswer, setFinalAnswer] = useState("");
  const [restOfContent, setRestOfContent] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);
  const [processedImages, setProcessedImages] = useState(new Map());
  const [processedMarkdown, setProcessedMarkdown] = useState(markdownText);
  // Use state to store the result
  const [hasLongReasoning, setHasLongReasoning] = useState(false);
  const [suppressCodeHighlighting, setSuppressCodeHighlighting] = useState(false);
  const [thinkingStopped, setThinkingStopped] = useState(false);
  const containerRef = useRef(null);
  const [isActionVisible, setIsActionVisible] = React__default.useState(false);
  const {
    currentTheme,
    mode
  } = useTheme();
  const [isValid, setIsValid] = React__default.useState(false);
  // Add the CSS in your component
  const markdownStyle = {
    ...style
  };
  const delayedStreamingFeedback = useRef(debounce((markdownText, setIsMessageStreaming) => {
    setIsMessageStreaming(markdownText.endsWith("\u26AB") || markdownText.endsWith("\u26AA"));
  }, 500)).current;
  useEffect(() => {
    delayedStreamingFeedback(markdownText, setIsMessageStreaming);
  }, [markdownText, delayedStreamingFeedback, setIsMessageStreaming]);
  useEffect(() => {
    // Registering a function on the window object
    window.copyToClipboard = async id => {
      const codeElement = document.getElementById("".concat(id, "_code"));
      try {
        await navigator.clipboard.writeText(codeElement === null || codeElement === void 0 ? void 0 : codeElement.innerText);
      } catch {
        var _window, _window$parent;
        console.log("Failed to copy");
        // send a message to the user that the copy failed
        (_window = window) === null || _window === void 0 ? void 0 : (_window$parent = _window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage({
          type: "tf_clipboard_iframe",
          message: codeElement === null || codeElement === void 0 ? void 0 : codeElement.innerText
        }, "*");
      }
    };
    return () => {
      delete window.copyToClipboard;
    };
  }, []);
  function extractMermaidCode(input) {
    const startIndicator = "```mermaid";
    const endIndicator = "```";
    const startIndex = input.indexOf(startIndicator);
    const endIndex = input.indexOf(endIndicator, startIndex + startIndicator.length);
    if (startIndex === -1 || endIndex === -1) {
      return input;
    }
    return input.substring(startIndex + startIndicator.length, endIndex).trim();
  }
  useEffect(() => {
    // Find all the elements with the class name 'error-icon'
    const errorText = document.querySelectorAll(".error-text");

    // Loop through the elements
    errorText.forEach((text, index) => {
      if (index === 0) {
        // Replace the content of the first error icon
        text.innerHTML = "";
      } else {
        // Remove the other error icons
        text.innerHTML = "The agent could not produce a valid chart";
      }
    });
  });
  // Define the regex pattern

  const processStreamedContent = (content, hideReasoning, isMessageStreaming) => {
    // const thinkPattern = /<think>([\s\S]*?)<\/think>/;
    // const match = content.match(thinkPattern);
    if (content !== null && content !== void 0 && content.includes("<think>")) setHasLongReasoning(true);
    if (content.includes("</think>")) {
      setThinkingStopped(true);
      const [beforeThink, afterThink] = content.split("</think>");
      return {
        restOfContent: beforeThink.trim(),
        answer: afterThink.trim()
      };
    } else {
      // If </think> is not present, everything goes to restOfContent
      return {
        restOfContent: isMessageStreaming ? content.trim() : "",
        answer: isMessageStreaming ? "" : content.trim()
      };
    }

    // else {
    //   // Original behavior when hideReasoning is false
    //   if (match) {
    //     const thinkContent = match[1].trim();
    //     const [beforeThink, afterThink] = content.split("</think>");
    //     setHasLongReasoning(true);
    //     return {
    //       restOfContent:
    //         beforeThink.split("<think>")[0].trim() + " " + thinkContent,
    //       answer: afterThink.trim(),
    //     };
    //   } else if (content.includes("<think>")) {
    //     setHasLongReasoning(true);
    //     return {
    //       restOfContent: content.trim(),
    //       answer: "",
    //     };
    //   } else {
    //     setHasLongReasoning(false);
    //     return {
    //       restOfContent: "",
    //       answer: content.trim(),
    //     };
    //   }
    // }
  };

  useEffect(() => {
    if (processedMarkdown) {
      const {
        restOfContent,
        answer
      } = processStreamedContent(processedMarkdown, hideReasoning, isMessageStreaming);
      setRestOfContent(restOfContent);
      setFinalAnswer(answer);
    }
  }, [processedMarkdown, hideReasoning, isMessageStreaming]);
  const validateMermaid = async () => {
    try {
      if (processedMarkdown !== null && processedMarkdown !== void 0 && processedMarkdown.includes("mermaid")) {
        if (processedMarkdown !== null && processedMarkdown !== void 0 && processedMarkdown.includes("zenuml")) {
          setIsValid(true);
        } else {
          const result = await mermaid.parse(extractMermaidCode(processedMarkdown));
        }
        setIsValid(true);
      }
    } catch (err) {
      setIsValid(false);
    }
  };
  useEffect(() => {
    const processMarkdown = async markdownText => {
      const imageRegex = /!\[([^\]]*)\]\(([^\)]+)\)/g;
      let matches = Array.from(markdownText.matchAll(imageRegex));
      for (let match of matches) {
        match[0];
        let url = match[2];
        if (!processedImages.has(url) && !url.startsWith("http")) {
          // if url does not start with pdf-image then it is a local image
          let _filename = null;
          if (!url.startsWith("pdf-image")) {
            _filename = "imported-image/".concat(workspaceid, "/").concat(url);
          } else {
            _filename = "imported-image/".concat(url);
          }
          const newUrl = await S3downloadUrlRequest({
            filename: _filename,
            context: "pdf",
            workspaceid
          });
          setProcessedImages(prevState => new Map(prevState.set(url, newUrl)));
        }
      }
      return markdownText;
    };
    processMarkdown(markdownText);
  }, [markdownText, processedImages]);
  useEffect(() => {
    var _processedMarkdownTex;
    let processedMarkdownText = markdownText;
    const imageRegex = /!\[([^\]]*)\]\(([^\)]+)\)/g;
    let matches = Array.from(processedMarkdownText.matchAll(imageRegex));
    matches.forEach(match => {
      const fullMatch = match[0];
      let url = match[2];
      if (processedImages.has(url) && !url.startsWith("http")) {
        const newUrl = processedImages.get(url);
        processedMarkdownText = processedMarkdownText.replace(fullMatch, fullMatch.replace(url, newUrl === null || newUrl === void 0 ? void 0 : newUrl.url));
      }
    });
    if (coder == false && !((_processedMarkdownTex = processedMarkdownText) !== null && _processedMarkdownTex !== void 0 && _processedMarkdownTex.includes("```mermaid"))) {
      const regex = /(```(?:markdown)?\s*\n?([\s\S]*?)\n?```)/g;
      processedMarkdownText = processedMarkdownText.replace(regex, "$2");
    }
    if (!showCodeInExecution) processedMarkdownText = replaceCodeBlocksWithPlaceholder(processedMarkdownText);
    setProcessedMarkdown(processedMarkdownText);
    validateMermaid();
  }, [markdownText, processedImages]);
  function replaceCodeBlocksWithPlaceholder(markdown) {
    // Regular expression to match code blocks in markdown, excluding Mermaid
    const codeBlockRegex = /```(?!mermaid\b)(\w*\n[\s\S]*?```)/g;

    // Replace code blocks with placeholder, preserving the language if specified
    const placeholderMarkdown = markdown.replace(codeBlockRegex, (match, p1) => {
      const lang = p1.split("\n")[0].trim();
      return "```" + (lang ? lang + "\n" : "\n") + "Suppressed code block\n```";
    });
    return placeholderMarkdown;
  }
  useEffect(() => {
    const loadMermaid = async () => {
      var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _currentTheme$theme11, _currentTheme$theme12, _currentTheme$theme13, _currentTheme$theme14, _currentTheme$theme15, _currentTheme$theme16, _currentTheme$theme17, _currentTheme$theme18, _currentTheme$theme19, _currentTheme$theme20, _currentTheme$theme21, _currentTheme$theme22, _currentTheme$theme23, _currentTheme$theme24, _currentTheme$theme25, _currentTheme$theme26, _currentTheme$theme27, _currentTheme$theme28, _currentTheme$theme29, _currentTheme$theme30, _currentTheme$theme31, _currentTheme$theme32, _currentTheme$theme33, _currentTheme$theme34, _currentTheme$theme35, _currentTheme$theme36;
      mermaid.initialize({
        startOnLoad: true,
        darkMode: mode == "dark",
        theme: "base",
        themeVariables: {
          background: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.backgroundColor,
          primaryColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.primaryColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary),
          primaryTextColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.primaryTextColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.white),
          primaryBorderColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.primaryBorderColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.primary),
          lineColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.lineColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.darkGrey),
          secondaryColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.secondaryColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.mediumGrey),
          tertiaryColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.tertiaryColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.lightGrey),
          fontFamily: "normalFont",
          fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.small_font_size,
          primaryTextColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.font_color,
          quadrant1Fill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.lightGrey,
          quadrant2Fill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.lightGrey,
          quadrant3Fill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.lightGrey,
          quadrant4Fill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.lightGrey,
          quadrant1TextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.primary,
          quadrant2TextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme15 = currentTheme.theme) === null || _currentTheme$theme15 === void 0 ? void 0 : _currentTheme$theme15.primary,
          quadrant3TextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme16 = currentTheme.theme) === null || _currentTheme$theme16 === void 0 ? void 0 : _currentTheme$theme16.primary,
          quadrant4TextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme17 = currentTheme.theme) === null || _currentTheme$theme17 === void 0 ? void 0 : _currentTheme$theme17.primary,
          quadrantPointFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme18 = currentTheme.theme) === null || _currentTheme$theme18 === void 0 ? void 0 : _currentTheme$theme18.primary,
          quadrantPointTextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme19 = currentTheme.theme) === null || _currentTheme$theme19 === void 0 ? void 0 : _currentTheme$theme19.primary,
          quadrantXAxisTextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme20 = currentTheme.theme) === null || _currentTheme$theme20 === void 0 ? void 0 : _currentTheme$theme20.font_color,
          quadrantYAxisTextFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme21 = currentTheme.theme) === null || _currentTheme$theme21 === void 0 ? void 0 : _currentTheme$theme21.font_color,
          quadrantInternalBorderStrokeFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme22 = currentTheme.theme) === null || _currentTheme$theme22 === void 0 ? void 0 : _currentTheme$theme22.darkGrey,
          quadrantExternalBorderStrokeFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme23 = currentTheme.theme) === null || _currentTheme$theme23 === void 0 ? void 0 : _currentTheme$theme23.darkGrey,
          quadrantAxisLineStrokeFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme24 = currentTheme.theme) === null || _currentTheme$theme24 === void 0 ? void 0 : _currentTheme$theme24.font_color,
          quadrantPointStrokeFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme25 = currentTheme.theme) === null || _currentTheme$theme25 === void 0 ? void 0 : _currentTheme$theme25.font_color,
          quadrantTitleFill: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme26 = currentTheme.theme) === null || _currentTheme$theme26 === void 0 ? void 0 : _currentTheme$theme26.font_color,
          xyChart: {
            backgroundColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.xyBackgroundColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme27 = currentTheme.theme) === null || _currentTheme$theme27 === void 0 ? void 0 : _currentTheme$theme27.transparent),
            titleColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.titleColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme28 = currentTheme.theme) === null || _currentTheme$theme28 === void 0 ? void 0 : _currentTheme$theme28.font_color),
            xAxisLabelColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.xAxisLabelColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme29 = currentTheme.theme) === null || _currentTheme$theme29 === void 0 ? void 0 : _currentTheme$theme29.font_color),
            yAxisLabelColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.yAxisLabelColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme30 = currentTheme.theme) === null || _currentTheme$theme30 === void 0 ? void 0 : _currentTheme$theme30.font_color),
            yAxisTitleColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.yAxisTitleColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme31 = currentTheme.theme) === null || _currentTheme$theme31 === void 0 ? void 0 : _currentTheme$theme31.font_color),
            xAxisTitleColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.xAxisTitleColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme32 = currentTheme.theme) === null || _currentTheme$theme32 === void 0 ? void 0 : _currentTheme$theme32.font_color),
            yAxisLineColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.yAxisLineColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme33 = currentTheme.theme) === null || _currentTheme$theme33 === void 0 ? void 0 : _currentTheme$theme33.font_color),
            xAxisLineColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.xAxisLineColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme34 = currentTheme.theme) === null || _currentTheme$theme34 === void 0 ? void 0 : _currentTheme$theme34.font_color),
            yAxisTickColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.yAxisTickColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme35 = currentTheme.theme) === null || _currentTheme$theme35 === void 0 ? void 0 : _currentTheme$theme35.font_color),
            xAxisTickColor: (customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.xAxisTickColor) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme36 = currentTheme.theme) === null || _currentTheme$theme36 === void 0 ? void 0 : _currentTheme$theme36.font_color),
            plotColorPalette: "".concat((customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.plotPrimaryColor) || "#1db8c6", ",").concat((customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.plotSecondaryColor) || "#E95E0B", ",").concat((customChartingConfig === null || customChartingConfig === void 0 ? void 0 : customChartingConfig.plotTertiaryColor) || "#28c552", ", #f10b0b")
          }
        },
        flowchart: {
          useMaxWidth: false,
          //if the flowchart should not use the whole available width then set this to false
          textMargin: 20 //increased margin around the text
        }
      });

      await mermaid.registerExternalDiagrams([zenuml]);
      mermaid.contentLoaded();
    };
    if (containerRef.current && processedMarkdown !== null && processedMarkdown !== void 0 && processedMarkdown.includes("```mermaid")) {
      setSuppressCodeHighlighting(true);
      loadMermaid();
    } else {
      setSuppressCodeHighlighting(false);
    }
  }, [currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.mode, processedMarkdown, isValid, isMessageStreaming, JSON.stringify(customChartingConfig)]);
  //  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  // <path fill="rgb(29, 184, 198)" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  // </svg>

  const md = new MarkdownIt({
    breaks: !coder,
    html: renderHTMLinMarkdown,
    linkify: renderHTMLinMarkdown,
    highlight: function (str, lang) {
      var _currentTheme$theme37;
      const _id = Math.random().toString(36).substring(2, 8);
      const part1highlight = "<script>\n      function copyToClipboard(value) {\n        var $temp = $(\"<input>\");\n        $(\"body\").append($temp);\n        $temp.val(value).select();\n        document.execCommand(\"copy\");\n        $temp.remove();\n      }\n      function viewHTML(id) {\n        const content = document.getElementById(id + \"_code\").textContent;\n        const newTab = window.open();\n        newTab.document.write(content);\n        newTab.document.close();\n      }\n    </script>\n   <pre><div class=\"code-top-bar ".concat(mode, "\">\n      <span style=\"font-size: 12px; color: inherit\">").concat(!showCodeInExecution ? "" : lang, "</span>\n      <div class=\"code-top-bar-buttons\">\n        <span onclick=\"copyToClipboard('").concat(_id, "')\" id=").concat(_id, " class=\"markdown-it-code-copy code-button\" ").concat(!showCodeInExecution ? "style='display: none;'" : "", " title=\"Copy\">Copy</span>\n        ").concat(lang.toLowerCase() === "html" ? "<span onclick=\"window.viewHTML('".concat(_id, "')\" class=\"markdown-it-code-view code-button\" ").concat(!showCodeInExecution ? "style='display: none;'" : "", " title=\"View HTML\">Preview</span>") : "", "\n      </div>\n    </div><code id=").concat(_id + "_code", " class=\"hljs ").concat(mode, "\">");
      if (lang && lang.toLowerCase() === "mermaid" && isValid && !isMessageStreaming && renderHTMLinMarkdown) {
        return "<pre style=\"overflow: auto;\"><div class=\"mermaid ".concat(mode, "\">") + str + "</div></pre>";
      } else if (lang && lang.toLowerCase() === "mermaid" && (!isValid || isMessageStreaming) && renderHTMLinMarkdown) return "<div class=\"mermaid-placeholder\" style=\"color: ".concat(currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme37 = currentTheme.theme) === null || _currentTheme$theme37 === void 0 ? void 0 : _currentTheme$theme37.font_color, "; font-size: 14px; font-family: boldFont\">") + "Plotting..." + "</div>";else if (lang && hljs.getLanguage(lang) && !suppressCodeHighlighting && lang !== "mermaid" && lang !== "markdown" && renderHTMLinMarkdown) {
        try {
          return part1highlight + hljs.highlight(str, {
            language: lang,
            ignoreIllegals: true
          }).value + "</code></pre>";
        } catch (__) {}
      }
      return !suppressCodeHighlighting ? part1highlight + md.utils.escapeHtml(str) + "</code></pre>" : str;
    }
  });

  // Intercept and load images before rendering markdown
  md.renderer.rules.image = function (tokens, idx, options, env, self) {
    const token = tokens[idx];
    const srcIndex = token.attrIndex("src");
    if (srcIndex >= 0) {
      const imgUrl = token.attrs[srcIndex][1];

      // Create a new image object and set its src to trigger loading
      const img = new Image();
      img.src = imgUrl;
    }

    // Default renderer for images
    return self.renderToken(tokens, idx, options);
  };
  md.use(markdownItKatex, {});
  // if (!suppressCodeHighlighting) md.use(markdownHighlight, { inline: false });
  md.use(mila, {
    attrs: {
      target: "_blank",
      rel: "noopener"
    }
  });
  const html = md.render(!renderHTMLinMarkdown ? processedMarkdown.replace(/\n/g, "\n\n") : processedMarkdown);
  const computeAspectRatio = svg => {
    const width = svg.width.baseVal.value;
    const height = svg.height.baseVal.value;
    return width / height;
  };
  const computeDimensions = ratio => {
    let targetWidth, targetHeight;

    // if width > height (landscape)
    if (ratio > 1) {
      targetWidth = Math.min(750, Math.max(350, ratio * 350));
      targetHeight = targetWidth / ratio;
    } else {
      targetHeight = Math.min(750, Math.max(350, 350 / ratio));
      targetWidth = targetHeight * ratio;
    }
    return {
      width: targetWidth,
      height: targetHeight
    };
  };
  const svgToDataURL = async (svg, width, height) => {
    return new Promise((resolve, reject) => {
      // Serialize SVG
      const serializedSVG = new XMLSerializer().serializeToString(svg);

      // Base64 encode and create DataURL
      const svgBase64 = btoa(unescape(encodeURIComponent(serializedSVG)));
      const svgDataURL = "data:image/svg+xml;base64," + svgBase64;

      // Create image to hold SVG DataURL
      const img = new Image();
      const SCALE_FACTOR = 2; // Adjust as needed for higher or lower quality

      img.onload = function () {
        // Create canvas and set its size with the scaling factor
        const canvas = document.createElement("canvas");
        canvas.width = width * SCALE_FACTOR;
        canvas.height = height * SCALE_FACTOR;
        const ctx = canvas.getContext("2d");
        // ctx.scale(SCALE_FACTOR, SCALE_FACTOR);
        ctx.drawImage(img, 0, 0, width * SCALE_FACTOR, height * SCALE_FACTOR);

        // Get PNG DataURL from canvas
        const pngDataURL = canvas.toDataURL("image/png", 1.0); // 1.0 = full quality
        resolve(pngDataURL);
      };
      img.onerror = function () {
        reject("Failed to load image");
      };
      img.src = svgDataURL;
    });
  };
  const removeBackgrounds = node => {
    const backgrounds = [];
    let counter = 0; // Introduce a counter
    while (node && counter < 10) {
      // Check counter
      backgrounds.push(node.style.backgroundColor);
      node.style.backgroundColor = "transparent";
      node = node.parentNode;
      counter++; // Increment the counter
    }

    return backgrounds;
  };
  const restoreBackgrounds = (node, backgrounds) => {
    let i = 0;
    let counter = 0; // Introduce a counter
    while (node && i < backgrounds.length && counter < 10) {
      // Check counter
      node.style.backgroundColor = backgrounds[i++];
      node = node.parentNode;
      counter++; // Increment the counter
    }
  };

  const handleCopy = async () => {
    if (containerRef.current) {
      const tempNodes = [];
      try {
        onCopy();
        const selection = window.getSelection();
        const svgs = containerRef.current.querySelectorAll("svg");
        for (let svg of svgs) {
          const ratio = computeAspectRatio(svg);
          const {
            width: targetWidth,
            height: targetHeight
          } = computeDimensions(ratio);
          const dataURL = await svgToDataURL(svg, targetWidth, targetHeight);
          const img = document.createElement("img");
          img.width = targetWidth;
          img.height = targetHeight;
          img.src = dataURL;

          // Remember the position of SVG and temporarily remove it
          const {
            parentNode,
            nextSibling
          } = svg;
          parentNode.removeChild(svg);

          // Insert the image in the place where SVG was
          parentNode.insertBefore(img, nextSibling);
          tempNodes.push({
            img,
            svg,
            parentNode,
            nextSibling
          });
        }
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }
        const backgrounds = removeBackgrounds(containerRef.current);
        containerRef.current.overflow = "none";
        const range = document.createRange();
        range.selectNode(containerRef.current);
        selection.addRange(range);
        try {
          // Attempt to copy
          const successful = document.execCommand("copy");
          const message = successful ? "Copied!" : "Failed to copy.";
          console.log(message);
        } catch (err) {
          console.error("Unable to copy", err);
        }
        restoreBackgrounds(containerRef.current, backgrounds);

        // Clear selection after copying
        selection.removeAllRanges();
      } catch (err) {
        console.log("Failed to copy: ", err);
      } finally {
        for (let {
          img,
          svg,
          parentNode,
          nextSibling
        } of tempNodes) {
          parentNode.removeChild(img);
          parentNode.insertBefore(svg, nextSibling);
        }
      }
    }
  };
  // from html object extract all the href and put them in an array called links
  const links = [];
  const htmlObject = document.createElement("div");
  htmlObject.innerHTML = html;
  const hrefs = htmlObject.querySelectorAll("a");
  hrefs.forEach(href => {
    // add the link only if app.toothfairyai.com or app.toothfairylab.link is not present in the link. Add a check where if the title link is tframe then do not add it to the links array
    if (!href.href.includes("app.toothfairyai.com") && !href.href.includes("app.toothfairylab.link") && href.title !== "tframe") {
      links.push(href.href);
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      flexDirection: "column",
      display: "flex"
    },
    onMouseEnter: e => {
      setIsActionVisible(true);
    },
    onMouseLeave: e => {
      setIsActionVisible(false);
    }
  }, isActionVisible && showCopyButton && /*#__PURE__*/React__default.createElement(View, {
    style: {
      position: "absolute",
      right: 0,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center"
    }
  }, showFeedbackButtons && /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      alignItems: "center",
      gap: 10
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.thumbsDown,
    color: copyIconColor,
    size: 16,
    onPress: onNegativeFeedbackPress,
    isClickable: true
  }), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.thumbsUp,
    color: copyIconColor,
    size: 16,
    onPress: onPositiveFeedbackPress,
    isClickable: true
  })), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.quickCopy,
    color: copyIconColor,
    size: 16,
    onPress: handleCopy,
    isClickable: true
  }), showTextToSpeech && /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.speakers,
    color: isSpeechGettingProcessed ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme38 = currentTheme.theme) === null || _currentTheme$theme38 === void 0 ? void 0 : _currentTheme$theme38.darkGrey : copyIconColor,
    size: 16,
    onPress: () => {
      updateTextForSpeech(processedMarkdown);
    },
    isClickable: !isSpeechGettingProcessed
  })), hasLongReasoning ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingTop: 20
    },
    className: "reasoning-container"
  }, restOfContent && /*#__PURE__*/React__default.createElement(AppText, {
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme39 = currentTheme.theme) === null || _currentTheme$theme39 === void 0 ? void 0 : _currentTheme$theme39.orange,
    rightIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme40 = currentTheme.theme) === null || _currentTheme$theme40 === void 0 ? void 0 : _currentTheme$theme40.orange,
    wrapperStyle: {
      width: "fit-content"
    },
    style: {
      textDecorationColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme41 = currentTheme.theme) === null || _currentTheme$theme41 === void 0 ? void 0 : _currentTheme$theme41.orange,
      fontWeight: "bold",
      marginLeft: 5
    },
    leftIcon: isMessageStreaming && !thinkingStopped ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.reasoning : !hideReasoning ? null : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons2 = AppAssets.icons) === null || _AppAssets$icons2 === void 0 ? void 0 : _AppAssets$icons2.thoughts,
    iconSize: 16,
    rightIcon: !hideReasoning ? null : !isExpanded ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons3 = AppAssets.icons) === null || _AppAssets$icons3 === void 0 ? void 0 : _AppAssets$icons3.expandReasoning : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons4 = AppAssets.icons) === null || _AppAssets$icons4 === void 0 ? void 0 : _AppAssets$icons4.collapseReasoning,
    isClickable: hideReasoning,
    onPress: toggleExpand
  }, "".concat(isMessageStreaming && !thinkingStopped ? "Thinking..." : "".concat(!hideReasoning ? "" : "Thoughts"))), isExpanded && /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: {
      ...markdownStyle,
      borderRadius: 0,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 10,
      borderLeftColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme42 = currentTheme.theme) === null || _currentTheme$theme42 === void 0 ? void 0 : _currentTheme$theme42.orange,
      borderRightColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme43 = currentTheme.theme) === null || _currentTheme$theme43 === void 0 ? void 0 : _currentTheme$theme43.transparent,
      borderTopColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme44 = currentTheme.theme) === null || _currentTheme$theme44 === void 0 ? void 0 : _currentTheme$theme44.transparent,
      borderBottomColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme45 = currentTheme.theme) === null || _currentTheme$theme45 === void 0 ? void 0 : _currentTheme$theme45.transparent
    },
    dangerouslySetInnerHTML: {
      __html: md.render(restOfContent)
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: isExpanded && 15
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: markdownStyle,
    dangerouslySetInnerHTML: {
      __html: md.render(finalAnswer)
    }
  }))) : /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: markdownStyle,
    ref: containerRef,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), renderHTMLLinkPreview && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginTop: 10
    }
  }, links && (links === null || links === void 0 ? void 0 : links.length) > 0 && [...new Set(links)].map((link, index) => {
    if (index < 6) {
      return /*#__PURE__*/React__default.createElement(LinkPreview, {
        key: index,
        url: link
      });
    }
  })));
};
MarkdownRenderer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MarkdownRenderer",
  "props": {
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "renderHTMLinMarkdown": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "coder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onPositiveFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onNegativeFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "isSpeechGettingProcessed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "updateTextForSpeech": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "showTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showCodeInExecution": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "renderDynamicHTML": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "renderHTMLLinkPreview": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "hideReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

const AppText = _ref => {
  let {
    children,
    style,
    color,
    fontWeight,
    width,
    textAlign,
    iconSize = 24,
    preventTranslation = false,
    rightIcon,
    leftIcon,
    wrapperStyle,
    onLeftIconPress,
    onRightIconPress,
    isClickable,
    onPress,
    trafficLightValue,
    isHoverable = isClickable,
    styleOnHover,
    isTextLeftAligned = false,
    emoji,
    leftIconStyle,
    iconHeight,
    iconWidth,
    numberOfLines,
    leftIconColor,
    rightIconColor,
    clickableViewWrapperStyle,
    renderMarkdown,
    showCopyButton = true,
    accessibilityLabel,
    markdownStyles = {},
    renderHTMLinMarkdown = true,
    showTextToSpeech = false,
    coder = false,
    customChartingConfig,
    S3downloadUrlRequest = () => {
      return "";
    },
    onCopy = () => {},
    workspaceid,
    copyIconColor,
    showFeedbackButtons,
    onPositiveFeedbackPress = () => {},
    onNegativeFeedbackPress = () => {},
    isSpeechGettingProcessed = false,
    updateTextForSpeech = () => {},
    showCodeInExecution = true,
    renderHTMLLinkPreview = true,
    hideReasoning = false,
    showTypingEffect = false,
    typingSpeed = 60,
    ...props
  } = _ref;
  //@ts-ignore
  const {
    currentTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isMouseHover, setIsMouseHover] = useState(false);
  const [displayedText, setDisplayedText] = useState("");
  const typingIntervalRef = useRef(null);
  const typingCompleteRef = useRef(false);
  const styles = generateStyles({
    currentTheme,
    fontWeight,
    color,
    isClickable,
    isMouseHover,
    isHoverable,
    rightIcon
  });
  let coreText;
  useEffect(() => {
    // Clean up on unmount
    return () => {
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (!showTypingEffect || typeof children !== "string" || typingCompleteRef.current) {
      setDisplayedText(children);
      return;
    }

    // Reset when children changes
    setDisplayedText("");
    typingCompleteRef.current = false;
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
    }
    const text = children;
    let currentIndex = 0;
    typingIntervalRef.current = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayedText(text.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        if (typingIntervalRef.current) {
          clearInterval(typingIntervalRef.current);
        }
        typingCompleteRef.current = true;
      }
    }, typingSpeed); // Adjust typing speed here (lower = faster)

    return () => {
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, [children, showTypingEffect]);
  if (renderMarkdown) {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4;
    coreText = /*#__PURE__*/React__default.createElement(ScrollView, {
      contentInsetAdjustmentBehavior: "automatic",
      style: {
        height: "100%"
      }
    }, Platform.OS === "web" ? /*#__PURE__*/React__default.createElement(MarkdownRenderer, {
      renderHTMLinMarkdown: renderHTMLinMarkdown,
      coder: coder,
      showCodeInExecution: showCodeInExecution,
      hideReasoning: hideReasoning,
      renderHTMLLinkPreview: renderHTMLLinkPreview,
      copyIconColor: copyIconColor,
      S3downloadUrlRequest: S3downloadUrlRequest,
      workspaceid: workspaceid,
      showCopyButton: showCopyButton,
      markdownText: children,
      onCopy: onCopy,
      style: {
        color: (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.small_font_size,
        fontFamily: "normalFont",
        ...markdownStyles
      },
      customChartingConfig: customChartingConfig,
      showFeedbackButtons: showFeedbackButtons,
      onPositiveFeedbackPress: onPositiveFeedbackPress,
      onNegativeFeedbackPress: onNegativeFeedbackPress,
      isSpeechGettingProcessed: isSpeechGettingProcessed,
      updateTextForSpeech: updateTextForSpeech,
      showTextToSpeech: showTextToSpeech
    }) : /*#__PURE__*/React__default.createElement(Markdown, {
      style: {
        body: {
          color: (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.font_color,
          fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.small_font_size,
          fontFamily: "normalFont",
          ...markdownStyles
        }
      }
    }, children));
  } else {
    coreText = /*#__PURE__*/React__default.createElement(Text, _extends({}, props, {
      accessibilityLabel: accessibilityLabel,
      numberOfLines: numberOfLines,
      style: [styles.text, style]
    }), preventTranslation ? showTypingEffect && typeof children === "string" ? displayedText : children : t(showTypingEffect && typeof children === "string" ? displayedText : children));
  }
  const coreTextComponent =
  /*#__PURE__*/
  //@ts-ignore
  React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    style: [styles.container, wrapperStyle, {
      cursor: isClickable && "pointer"
    }]
  }, leftIcon && /*#__PURE__*/React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    style: {
      flexDirection: "row",
      width: iconSize
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon
  // Remove this when AppIcon has been converted to typescript
  //@ts-ignore
  , {
    accessibilityLabel: accessibilityLabel,
    style: [styles.leftIcon, leftIconStyle],
    size: iconSize,
    emoji: emoji,
    icon: leftIcon,
    color: leftIconColor || color,
    height: iconHeight,
    width: iconWidth,
    isClickable: !!onLeftIconPress,
    onPress: onLeftIconPress
  }), trafficLightValue && /*#__PURE__*/React__default.createElement(AppDot, {
    forcedValue: trafficLightValue
  })), isTextLeftAligned ? /*#__PURE__*/React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    style: {
      flexDirection: "row",
      flex: 1
    }
  }, coreText) : coreText, rightIcon && /*#__PURE__*/React__default.createElement(AppIcon
  // Remove this when AppIcon has been converted to typescript
  //@ts-ignore
  , {
    style: {
      alignSelf: "center",
      marginLeft: 5,
      alignItems: "flex-end"
    },
    size: iconSize,
    icon: rightIcon,
    color: rightIconColor || color,
    height: iconHeight,
    width: iconWidth,
    isClickable: !!onRightIconPress,
    onPress: onRightIconPress,
    accessibilityLabel: accessibilityLabel
  }));
  return isClickable ? /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    accessibilityLabel: accessibilityLabel,
    onPress: onPress,
    style: clickableViewWrapperStyle
  }, coreTextComponent) : coreTextComponent;
};

//@todo: use Pick to select the props from a base theme / interface

const generateStyles = _ref2 => {
  var _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7;
  let {
    currentTheme,
    fontWeight,
    color,
    isMouseHover,
    isHoverable,
    rightIcon
  } = _ref2;
  return StyleSheet.create({
    leftIcon: {
      alignSelf: "center",
      marginRight: 5
    },
    container: {
      alignItems: "center",
      alignContent: "center",
      justifyContent: rightIcon ? "space-between" : "flex-start",
      flexDirection: "row"
    },
    text: {
      fontFamily: fontWeight && fontWeight !== "normal" ? "boldFont" : "normalFont",
      color: color || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.font_color),
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.small_font_size,
      textDecorationColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.primary,
      textDecorationLine: isMouseHover && isHoverable ? "underline" : "none"
    }
  });
};
AppText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppText",
  "props": {
    "iconSize": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Size of the icon both left and right"
    },
    "preventTranslation": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true renders the text as is without translating"
    },
    "isHoverable": {
      "defaultValue": {
        "value": "isClickable",
        "computed": true
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component shows an hover effect"
    },
    "isTextLeftAligned": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "Forces the text to be left aligned"
    },
    "showCopyButton": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "markdownStyles": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "renderHTMLinMarkdown": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "showTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "coder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "S3downloadUrlRequest": {
      "defaultValue": {
        "value": "() => {\n  return \"\";\n}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(url: string) => string",
        "signature": {
          "arguments": [{
            "name": "url",
            "type": {
              "name": "string"
            }
          }],
          "return": {
            "name": "string"
          }
        }
      },
      "description": ""
    },
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onPositiveFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onNegativeFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "isSpeechGettingProcessed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "updateTextForSpeech": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "showCodeInExecution": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "renderHTMLLinkPreview": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "hideReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "showTypingEffect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "typingSpeed": {
      "defaultValue": {
        "value": "60",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "children": {
      "required": true,
      "tsType": {
        "name": "union",
        "raw": "string | TemplateStringsArray | (string | TemplateStringsArray)[]",
        "elements": [{
          "name": "string"
        }, {
          "name": "TemplateStringsArray"
        }, {
          "name": "Array",
          "elements": [{
            "name": "unknown"
          }],
          "raw": "(string | TemplateStringsArray)[]"
        }]
      },
      "description": "Text to display"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "TextStyle"
        }],
        "raw": "StyleProp<TextStyle>"
      },
      "description": "Style of the inner text"
    },
    "color": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Font color"
    },
    "fontWeight": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Whether the text will be displayed with normal or bold font"
    },
    "width": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Width of the overall component"
    },
    "textAlign": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Defines the direction in which the text is layed out"
    },
    "iconHeight": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Height of the icon both left and right"
    },
    "iconWidth": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Width of the icon both left and right"
    },
    "rightIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "When a fontawesome icon is passed, an icon to the right side is displayed"
    },
    "leftIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "When a fontawesome icon is passed, an icon to the left side is displayed"
    },
    "wrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of view wrapping all sub-components"
    },
    "onLeftIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event triggered when the left icon is clicked"
    },
    "onRightIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event triggered when the right icon is clicked"
    },
    "isClickable": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component becomes clickable"
    },
    "onPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when the component is pressed - only applicable when the isClickable is set to true"
    },
    "trafficLightValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Dot displayed to the left side of the component to signify a notification hint - based on the value the colour changes from red to green"
    },
    "styleOnHover": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Style to apply when the component is hovered - only applicable when the isHoverable is set to true"
    },
    "emoji": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "When passed, it displays an emoji on the left hand side. All other props passed to the left icon can still be applied"
    },
    "leftIconStyle": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "Style to apply to the left icon - both emoji and fontawesome"
    },
    "numberOfLines": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Defines how many times text can be wrapped"
    },
    "leftIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color to apply to the left icon - both emoji and fontawesome"
    },
    "rightIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color to apply to the right icon - both emoji and fontawesome"
    },
    "onLayout": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(event: LayoutChangeEvent) => void",
        "signature": {
          "arguments": [{
            "name": "event",
            "type": {
              "name": "LayoutChangeEvent"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "accessibilityLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "clickableViewWrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply when to the clickable component wrapping AppText when isClickable is set to true"
    },
    "renderMarkdown": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "workspaceid": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "copyIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "customChartingConfig": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "showFeedbackButtons": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    }
  }
};

export { AppText as A, AppIcon as a };
